import React, { memo, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import EmailLeftbar from "../components/EmailLeftbar";
import DefaultView from "../components/DefaultView";
import { toast } from "react-toastify";
import { actionComposeFax } from "../store/actions/inboxAction";
import {
  actionGetFaxHeader,
  actionGetAlerts,
  actionGetFromNumbers,
} from "../store/actions/settingAction";
import { connect } from "react-redux";
import moment from "moment";
import TagsInput from "react-tagsinput";
import { actionGetContacts } from "../store/actions/authAction";
import { actionGetSendFaxNumbers } from "../store/actions/sentFaxesAction";
import { PDFDocument } from "pdf-lib";
import Swal from "sweetalert2";

import "react-tagsinput/react-tagsinput.css";

const ComponseFax = memo(
  ({
    actionGetFaxHeader,
    actionGetAlerts,
    faxHeaderData,
    faxHeaderloder,
    alertLoader,
    alertData,
    user,
    actionComposeFax,
    composeFaxLoader,
    actionGetFromNumbers,
    getFromNumberLoader,
    fromNumbers,
    actionGetContacts,
    contacts,
    contactsLoader,
    actionGetSendFaxNumbers,
    sentFaxNumbers,
    getSentFaxNumbersLoader,
  }) => {
    const [isContactsModalOpen, setIsContactsModalOpen] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [contactsQuery, setContactsQuery] = useState("");
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [radioType, setRadioType] = useState("SEND_NOW");
    const [faxNumber, setFaxNumber] = useState([]);
    const [header, setHeader] = useState("");
    const [fromNumber, setFromNumber] = useState("");
    const [alert, setAlert] = useState("");
    const [dateTime, setDateTime] = useState("");
    const [errors, setErrors] = useState({});
    const [showQueuedAlert, setShowQueuedAlert] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [isCalculatingPages, setIsCalculatingPages] = useState(false);

    // Recent-number suggestions state
    const [tagInputValue, setTagInputValue] = useState("");
    const [showSentSuggestions, setShowSentSuggestions] = useState(false);
    const [filteredSentSuggestions, setFilteredSentSuggestions] = useState([]);

    // Initialize Bootstrap tooltips
    useEffect(() => {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => {
        return new window.bootstrap.Tooltip(tooltipTriggerEl);
      });

      // Cleanup function to dispose tooltips when component unmounts
      return () => {
        tooltipList.forEach((tooltip) => tooltip.dispose());
      };
    }, []);

    useEffect(() => {
      actionGetFaxHeader();
      actionGetAlerts();
      actionGetFromNumbers();
      // fetch contacts for contact picker
      actionGetContacts();
      actionGetSendFaxNumbers();
    }, [
      actionGetFaxHeader,
      actionGetAlerts,
      actionGetFromNumbers,
      actionGetContacts,
      actionGetSendFaxNumbers,
    ]);

    // Auto-select first alert when available
    useEffect(() => {
      if (alertData && alertData.length > 0 && !alert) {
        setAlert(alertData[0].alert_ID);
      }
    }, [alertData, alert]);

    // Auto-select first header when available
    useEffect(() => {
      if (faxHeaderData && faxHeaderData.length > 0 && !header) {
        setHeader(faxHeaderData[0].header_ID);
      }
    }, [faxHeaderData, header]);

    // Prepare filtered recent sent numbers for suggestions
    useEffect(() => {
      const q = (tagInputValue || "").replace(/[-\s()]/g, "");
      if (!sentFaxNumbers || sentFaxNumbers.length === 0) {
        setFilteredSentSuggestions([]);
        return;
      }

      const list = sentFaxNumbers
        .map((n) =>
          typeof n === "object" ? n.number || n.value || "" : String(n)
        )
        .map((n) => cleanNumber(n))
        .filter((n) => n) // non-empty
        .filter((n) => !faxNumber.includes(n)); // avoid already-selected

      const filtered = q ? list.filter((n) => n.includes(q)) : list;
      setFilteredSentSuggestions(filtered.slice(0, 5));
    }, [tagInputValue, sentFaxNumbers, faxNumber]);

    const Extension = process.env.REACT_APP_ALLOWED_EXTENSIONS.split(", ");
    const MAX_PAGES = parseInt(
      process.env.REACT_APP_MAX_PAGES_LIMIT || "30",
      10
    );
    const MAX_FILE_SIZE_MB = parseInt(
      process.env.REACT_APP_MAX_FILE_SIZE_MB || "50",
      10
    );
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert MB to bytes

    const handleInputChange = (e) => {
      setInputValue(e.target.value);
    };

    const removeFile = (fileToRemove) => {
      const updatedFiles = uploadedFiles.filter(
        (file) => file !== fileToRemove
      );
      setUploadedFiles(updatedFiles);
      // Recalculate total pages
      const newTotal = updatedFiles.reduce(
        (sum, f) => sum + (f.pageCount || 1),
        0
      );
      setTotalPages(newTotal);
    };

    // Function to count pages in a file
    const countPages = async (file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      // Image files = 1 page
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "ai", "psd"];
      if (imageExtensions.includes(fileExtension)) {
        return 1;
      }

      // PDF files - extract actual page count
      if (fileExtension === "pdf") {
        try {
          const arrayBuffer = await file.arrayBuffer();
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          return pdfDoc.getPageCount();
        } catch (error) {
          console.error("Error counting PDF pages:", error);
          toast.error(`Could not read PDF: ${file.name}`);
          return 0;
        }
      }

      // For doc, docx, xls, xlsx, ppt, pptx, txt, rtf, etc.
      // We estimate based on file size (approximate)
      const sizeInKB = file.size / 1024;

      if (["doc", "docx", "txt", "rtf", "odt", "md"].includes(fileExtension)) {
        // Roughly 50KB per page for documents
        return Math.max(1, Math.ceil(sizeInKB / 50));
      }

      if (["xls", "xlsx", "csv", "ods"].includes(fileExtension)) {
        // Roughly 30KB per page for spreadsheets
        return Math.max(1, Math.ceil(sizeInKB / 30));
      }

      if (["ppt", "pptx", "odp", "key"].includes(fileExtension)) {
        // Roughly 100KB per slide
        return Math.max(1, Math.ceil(sizeInKB / 100));
      }

      if (["html", "htm", "xml", "tex", "ps", "epub"].includes(fileExtension)) {
        // Roughly 40KB per page
        return Math.max(1, Math.ceil(sizeInKB / 40));
      }

      // Default to 1 page for other supported formats
      return 1;
    };

    const onDrop = useCallback(
      async (acceptedFiles) => {
        const filteredFiles = acceptedFiles.filter((file) => {
          const fileExtension = file.name.split(".").pop().toLowerCase();
          return Extension.includes(fileExtension);
        });

        if (filteredFiles.length === 0) {
          toast.error("No valid files selected");
          return;
        }

        // Check file size for each file
        const oversizedFiles = filteredFiles.filter(
          (file) => file.size > MAX_FILE_SIZE
        );
        if (oversizedFiles.length > 0) {
          toast.error(
            `File(s) exceed maximum size of ${MAX_FILE_SIZE_MB}MB: ${oversizedFiles
              .map((f) => f.name)
              .join(", ")}`
          );
          return;
        }

        setIsCalculatingPages(true);

        const filesWithPreviews = await Promise.all(
          filteredFiles.map(async (file) => {
            const pageCount = await countPages(file);
            return {
              file,
              preview: URL.createObjectURL(file),
              pageCount,
            };
          })
        );

        const newUploadedFiles = [...uploadedFiles, ...filesWithPreviews];
        const newTotalPages = newUploadedFiles.reduce(
          (sum, f) => sum + (f.pageCount || 1),
          0
        );

        if (newTotalPages > MAX_PAGES) {
          toast.error(
            `Total pages exceed the maximum limit of ${MAX_PAGES} pages. Current total would be ${newTotalPages} pages.`
          );
          setIsCalculatingPages(false);
          return;
        }

        setUploadedFiles(newUploadedFiles);
        setTotalPages(newTotalPages);
        setIsCalculatingPages(false);
      },
      [uploadedFiles, Extension, MAX_PAGES, MAX_FILE_SIZE]
    );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      multiple: true,
    });

    const dropzoneStyle = {
      cursor: "pointer",
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const validateForm = () => {
      const newErrors = {};

      if (faxNumber.length === 0) {
        newErrors.faxNumber = "At least one fax number is required";
      }
      if (!fromNumber) {
        newErrors.fromNumber = "From Number is required";
      }
      if (uploadedFiles.length === 0) {
        newErrors.uploadedFiles = "File(s) are required";
      }
      if (totalPages > MAX_PAGES) {
        newErrors.uploadedFiles = `Total pages (${totalPages}) exceed maximum limit of ${MAX_PAGES} pages`;
      }
      if (!alert) {
        newErrors.alert = "Alert is required";
      }
      if (!header) {
        newErrors.header = "Header is required";
      }
      if (!dateTime && radioType != "SEND_NOW") {
        newErrors.dateTime = "Date & Time is required";
      }

      setErrors(newErrors);

      // Scroll to first error with improved targeting and animation
      if (Object.keys(newErrors).length > 0) {
        const firstErrorKey = Object.keys(newErrors)[0];

        setTimeout(() => {
          let element = null;

          // Find the appropriate element based on error type
          switch (firstErrorKey) {
            case "faxNumber":
              element =
                document.querySelector(".react-tagsinput input") ||
                document.querySelector(".react-tagsinput") ||
                document.querySelector(".custom-fax-number-input");
              break;
            case "fromNumber":
              // Find the "Select From Number" select element
              const selects = document.querySelectorAll("select");
              for (let sel of selects) {
                if (sel.options[0]?.text === "Select From Number") {
                  element = sel;
                  break;
                }
              }
              // Fallback: find by label
              if (!element) {
                const fromNumberLabel = Array.from(
                  document.querySelectorAll("label")
                ).find(
                  (label) => label.textContent.trim() === "Select From Number"
                );
                element = fromNumberLabel?.nextElementSibling;
              }
              break;
            case "alert":
              // Find the alert select
              const alertSelects = document.querySelectorAll("select");
              for (let sel of alertSelects) {
                if (sel.options[0]?.text === "Select Alert") {
                  element = sel;
                  break;
                }
              }
              break;
            case "header":
              // Find the header select
              const headerSelects = document.querySelectorAll("select");
              for (let sel of headerSelects) {
                if (sel.options[0]?.text === "Select Header") {
                  element = sel;
                  break;
                }
              }
              break;
            case "uploadedFiles":
              // Find the dropzone area
              element =
                document.querySelector('[role="presentation"]') ||
                document.querySelector(".dz-message") ||
                document.querySelector(".card-header h4");
              break;
            case "dateTime":
              element = document.querySelector('input[type="datetime-local"]');
              break;
            default:
              element = null;
          }

          if (element) {
            // Scroll with smooth behavior and proper offset
            const elementPosition =
              element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 200; // Increased offset to scroll up more

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });

            // Find the parent container for highlighting
            const fieldContainer =
              element.closest(".mb-1") ||
              element.closest(".col-md-12") ||
              element.closest(".card") ||
              element.parentElement;

            if (fieldContainer) {
              // Add visual highlight to the error field
              fieldContainer.style.transition = "all 0.3s ease";
              fieldContainer.style.boxShadow =
                "0 0 0 3px rgba(220, 53, 69, 0.25)";
              fieldContainer.style.borderRadius = "4px";

              // Remove highlight after animation
              setTimeout(() => {
                fieldContainer.style.boxShadow = "";
              }, 2000);
            }

            // Flash the error message if it exists
            const errorMsg = fieldContainer?.querySelector(".text-danger");
            if (errorMsg) {
              errorMsg.style.fontWeight = "bold";
              errorMsg.style.animation = "none";
              setTimeout(() => {
                errorMsg.style.animation = "pulse 0.5s ease-in-out 2";
              }, 10);
            }

            // Focus the element after scroll completes
            setTimeout(() => {
              if (
                element.tagName === "INPUT" ||
                element.tagName === "SELECT" ||
                element.tagName === "TEXTAREA"
              ) {
                element.focus();
                // Add a brief highlight to the input itself using outline (doesn't affect layout)
                const originalOutline = element.style.outline;
                const originalOutlineOffset = element.style.outlineOffset;
                element.style.outline = "2px solid #dc3545";
                element.style.outlineOffset = "2px";
                setTimeout(() => {
                  element.style.outline = originalOutline;
                  element.style.outlineOffset = originalOutlineOffset;
                }, 2000);
              } else {
                // For non-input elements, try to find and focus the first input/select inside
                const focusable = element.querySelector(
                  "input, select, textarea"
                );
                if (focusable) {
                  focusable.focus();
                  const originalOutline = focusable.style.outline;
                  const originalOutlineOffset = focusable.style.outlineOffset;
                  focusable.style.outline = "2px solid #dc3545";
                  focusable.style.outlineOffset = "2px";
                  setTimeout(() => {
                    focusable.style.outline = originalOutline;
                    focusable.style.outlineOffset = originalOutlineOffset;
                  }, 2000);
                }
              }
            }, 500); // Wait for scroll to complete
          }
        }, 100);
      }

      return Object.keys(newErrors).length === 0;
    };

    const handleSave = async (e) => {
      e.preventDefault();
      if (validateForm()) {
        const formData = new FormData();

        // Concatenate fax numbers into a single comma-separated string
        const concatenatedValues = faxNumber.join(",");

        formData.append("isSentMsg", true);
        formData.append("msg_fromNumber", fromNumber);
        formData.append("msg_toNumber", concatenatedValues);
        formData.append("msg_senderName", user.user_fullname);
        formData.append("user_ID", user.user_ID);
        formData.append("header_ID", header);
        formData.append("alert_ID", alert);
        formData.append(
          "msg_status",
          radioType == "SCHEDULE" ? "SCHEDULED" : "PENDING"
        );
        radioType == "SCHEDULE" &&
          formData.append(
            "schedule_msg_date_time",
            moment(dateTime).format("YYYY-MM-DD h:mm:ss a")
          );
        uploadedFiles.forEach((fileObj) => {
          formData.append("files", fileObj.file);
        });

        const result = await actionComposeFax(formData);
        if (result) {
          setUploadedFiles([]);
          setInputValue("");
          setRadioType("SEND_NOW");
          setFaxNumber([]);
          setDateTime("");
          setHeader("");
          setAlert("");
          setFromNumber("");
          setShowQueuedAlert(true);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      } else {
        console.log("Form has validation errors.");
      }
    };

    // Function to clean up fax numbers
    const cleanNumber = (number) => {
      const trimmed = number.trim();

      // Check if + appears anywhere except the start
      const plusCount = (trimmed.match(/\+/g) || []).length;
      if (plusCount > 1 || (plusCount === 1 && !trimmed.startsWith("+"))) {
        return null; // Invalid if + is in middle or multiple +
      }

      // Remove all non-digit characters except the leading +
      const cleaned = trimmed.replace(/[^\d+]/g, "");

      // Ensure + is only at the start
      if (cleaned.startsWith("+")) {
        const withoutPlus = cleaned.substring(1).replace(/\+/g, "");
        return "+" + withoutPlus;
      }
      return cleaned.replace(/\+/g, "");
    };

    // Function to validate phone number - minimum 8 numeric characters
    const validatePhoneNumber = (number) => {
      const trimmed = number.trim();

      // Check if + appears in the middle
      const plusCount = (trimmed.match(/\+/g) || []).length;
      if (plusCount > 1) {
        return {
          isValid: false,
          error: "Number cannot contain multiple '+' signs",
        };
      }
      if (plusCount === 1 && !trimmed.startsWith("+")) {
        return {
          isValid: false,
          error: "'+' sign can only be at the beginning",
        };
      }

      const cleaned = cleanNumber(trimmed);

      if (!cleaned) {
        return {
          isValid: false,
          error: "Invalid format: '+' can only be at the beginning",
        };
      }

      // Remove + sign for digit count
      const digitsOnly = cleaned.replace(/\+/g, "");

      // Check if it contains only digits (after removing +)
      if (!/^\d+$/.test(digitsOnly)) {
        return {
          isValid: false,
          error: "Number must contain only digits",
        };
      }

      // Check minimum length
      if (digitsOnly.length < 8) {
        return {
          isValid: false,
          error: "Number must be at least 8 digits long",
        };
      }

      return { isValid: true, formatted: cleaned };
    };

    const handleChangeNumber = async (tags) => {
      // Limit to max 5 numbers
      if (tags.length > 5) {
        await Swal.fire({
          icon: "warning",
          title: "Too Many Numbers",
          text: "You can only enter up to 5 fax numbers.",
          confirmButtonColor: "#556ee6",
        });
        return;
      }

      // Check for invalid '+' placement before cleaning
      const numbersWithInvalidPlus = [];
      for (const tag of tags) {
        const trimmed = tag.trim();
        const plusCount = (trimmed.match(/\+/g) || []).length;
        if (plusCount > 1 || (plusCount === 1 && !trimmed.startsWith("+"))) {
          numbersWithInvalidPlus.push(trimmed);
        }
      }

      // If there are numbers with invalid '+' placement, show alert
      if (numbersWithInvalidPlus.length > 0) {
        await Swal.fire({
          icon: "error",
          title: "Invalid '+' Placement",
          html: `
            <div style="text-align: left;">
              <p>The following number(s) have '+' sign in invalid position:</p>
              <ul style="color: #dc3545; font-weight: 600;">
                ${numbersWithInvalidPlus
              .map((num) => `<li>${num}</li>`)
              .join("")}
              </ul>
              <p style="margin-top: 15px; color: #666;">
                <strong>Note:</strong> The '+' sign can only be at the beginning of the number, not in the middle or at the end.
              </p>
              <p style="margin-top: 10px; color: #666;">
                <strong>Valid examples:</strong><br/>
                • +1234567890 ✓<br/>
                • 1234567890 ✓<br/>
                <br/>
                <strong>Invalid examples:</strong><br/>
                • 43546+5463 ✗<br/>
                • 123+456+789 ✗
              </p>
            </div>
          `,
          confirmButtonText: "OK, I'll fix it",
          confirmButtonColor: "#556ee6",
        });

        // Remove only the invalid numbers, keep valid ones
        const validTags = tags.filter((tag) => {
          const trimmed = tag.trim();
          const plusCount = (trimmed.match(/\+/g) || []).length;
          return !(
            plusCount > 1 ||
            (plusCount === 1 && !trimmed.startsWith("+"))
          );
        });

        // Continue processing valid tags
        tags = validTags;
      }

      // Clean tags
      const cleanedTags = tags
        .map((tag) => cleanNumber(tag))
        .filter((tag) => tag);

      // Remove duplicates
      const uniqueTags = Array.from(new Set(cleanedTags));

      // Validate each number
      const validatedNumbers = [];
      const invalidNumbers = [];

      for (const tag of uniqueTags) {
        const validation = validatePhoneNumber(tag);
        if (validation.isValid) {
          validatedNumbers.push(validation.formatted);
        } else {
          invalidNumbers.push({ number: tag, error: validation.error });
        }
      }

      // If there are invalid numbers (other than '+' placement), show SweetAlert
      if (invalidNumbers.length > 0) {
        await Swal.fire({
          icon: "error",
          title: "Invalid Fax Number(s)",
          html: `
            <div style="text-align: left;">
              <p>The following number(s) are invalid:</p>
              <ul style="color: #dc3545; font-weight: 600;">
                ${invalidNumbers
              .map((item) => `<li>${item.number} - ${item.error}</li>`)
              .join("")}
              </ul>              
              <p style="margin-top: 10px; color: #666;">
                <p>Valid examples:</strong><br/>
                • 12345678<br/>
                • +1234567890                
              </p>
            </div>
          `,
          confirmButtonText: "OK",
          confirmButtonColor: "#556ee6",
        });

        // Only keep valid numbers
        setFaxNumber(validatedNumbers);
        setErrors({});
      } else {
        // All numbers are valid
        setFaxNumber(validatedNumbers);
        setErrors({});
      }
    };

    const getContactNumber = (c) => {
      // try common possible fields for contact phone number
      return (
        c.contact_number ||
        c.phone ||
        c.mobile ||
        c.phoneNumber ||
        c.number ||
        ""
      );
    };

    const openContactsModal = () => {
      setIsContactsModalOpen(true);
      // initialize selection from current faxNumber
      setSelectedContacts([]);
      setContactsQuery("");
    };

    const closeContactsModal = () => {
      setIsContactsModalOpen(false);
    };

    const toggleContactSelection = (contact) => {
      const number = cleanNumber(getContactNumber(contact) || "");
      if (!number) {
        toast.error("Contact has no valid phone number.");
        return;
      }
      const exists = selectedContacts.find(
        (c) => cleanNumber(getContactNumber(c) || "") === number
      );
      if (exists) {
        // ensure removal uses cleaned comparison as well
        setSelectedContacts(
          selectedContacts.filter(
            (c) => cleanNumber(getContactNumber(c) || "") !== number
          )
        );
      } else {
        if (selectedContacts.length >= 5) {
          toast.error("You can only select up to 5 contacts.");
          return;
        }
        setSelectedContacts([...selectedContacts, contact]);
      }
    };

    const importSelectedContacts = () => {
      const numbers = selectedContacts
        .map((c) => cleanNumber(getContactNumber(c) || ""))
        .filter((n) => n && validatePhoneNumber(n).isValid);
      const unique = Array.from(new Set(numbers));
      if (unique.length === 0) {
        toast.error("No valid phone numbers selected.");
        return;
      }
      setFaxNumber(unique);
      setIsContactsModalOpen(false);
    };

    const handleTagInputChange = (value) => {
      setTagInputValue(value);
      setShowSentSuggestions(true);
    };

    // Handle paste event for comma-separated numbers
    const handlePaste = async (e) => {
      const pastedText = e.clipboardData.getData("text");

      if (pastedText.includes(",")) {
        e.preventDefault();

        // Split by comma and clean each number
        const numbers = pastedText
          .split(",")
          .map((num) => {
            const trimmed = num.trim();
            // Remove all characters except digits and +
            const cleaned = trimmed.replace(/[^\d+]/g, "");
            // Ensure + is only at the beginning
            if (cleaned.startsWith("+")) {
              return "+" + cleaned.substring(1).replace(/\+/g, "");
            }
            return cleaned;
          })
          .filter((num) => num.length > 0);

        // Validate each number
        const validatedNumbers = [];
        const invalidNumbers = [];

        for (const num of numbers) {
          const validation = validatePhoneNumber(num);
          if (validation.isValid) {
            validatedNumbers.push(validation.formatted);
          } else {
            invalidNumbers.push({ number: num, error: validation.error });
          }
        }

        // Remove duplicates and take first 5
        const unique = Array.from(new Set(validatedNumbers)).slice(0, 5);
        console.log("Valid unique numbers to add:", unique);

        // If there are invalid numbers, show SweetAlert
        if (invalidNumbers.length > 0) {
          await Swal.fire({
            icon: "warning",
            title: "Some Numbers Are Invalid",
            html: `
              <div style="text-align: left;">
                <p>Valid numbers added: <strong>${unique.length}</strong></p>
                ${invalidNumbers.length > 0
                ? `
                  <p style="margin-top: 10px;">Invalid numbers (not added):</p>
                  <ul style="color: #dc3545; font-weight: 600;">
                    ${invalidNumbers
                  .map((item) => `<li>${item.number} - ${item.error}</li>`)
                  .join("")}
                  </ul>
                  <p style="margin-top: 10px; color: #666;">
                    <strong>Requirements:</strong> Minimum 8 digits, only numeric characters.
                  </p>
                `
                : ""
              }
              </div>
            `,
            confirmButtonText: "OK",
            confirmButtonColor: "#556ee6",
          });
        }

        // Set only the valid fax numbers
        setFaxNumber(unique);
        setTagInputValue("");
        setErrors({});
      }
    };

    // Debounced server fetch: load sent fax numbers from server on type
    useEffect(() => {
      if (typeof actionGetSendFaxNumbers !== "function") return;
      const q = (tagInputValue || "").replace(/[-\s()]/g, "");
      const timer = setTimeout(() => {
        // Pass query string (action may accept an empty string to return recent items)
        actionGetSendFaxNumbers(q);
        setShowSentSuggestions(true);
      }, 400);

      return () => clearTimeout(timer);
    }, [tagInputValue, actionGetSendFaxNumbers]);

    const addSuggestion = (number) => {
      const cleaned = cleanNumber(number);
      if (!cleaned) return;

      // Validate the number before adding
      const validation = validatePhoneNumber(cleaned);
      if (!validation.isValid) {
        Swal.fire({
          icon: "error",
          title: "Invalid Number",
          text: `${cleaned} - ${validation.error}. Number must be at least 8 digits long.`,
          confirmButtonColor: "#556ee6",
        });
        return;
      }

      const next = Array.from(
        new Set([...faxNumber, validation.formatted])
      ).slice(0, 5);
      setFaxNumber(next);
      setTagInputValue("");
      setShowSentSuggestions(false);
    };

    // Close suggestion list on outside click
    useEffect(() => {
      const handler = (e) => {
        // Check if click is outside the suggestions dropdown and input
        const suggestionsEl = document.querySelector(".sent-suggestions");
        const inputEl = document.querySelector(".custom-fax-number-input");

        if (
          suggestionsEl &&
          !suggestionsEl.contains(e.target) &&
          inputEl &&
          !inputEl.contains(e.target)
        ) {
          setShowSentSuggestions(false);
        }
      };

      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, []);

    return (
      <div className="main-content">
        <div className="page-content">
          {composeFaxLoader && (
            <div className="fullscreen-loader" role="status" aria-live="polite">
              <div className="fullscreen-loader-backdrop" />
              <div className="fullscreen-loader-content">
                <span className="fax-anim" aria-hidden>
                  <svg
                    viewBox="0 0 36 36"
                    width="64"
                    height="64"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-label="Sending fax"
                  >
                    <g className="fax-paper-group">
                      <rect
                        x="6"
                        y="4"
                        width="18"
                        height="24"
                        rx="2"
                        className="fax-paper"
                        strokeWidth="1.6"
                      />
                      <path d="M24 4v6l4 0" className="fax-paper" />
                    </g>
                    <g className="fax-lines" transform="translate(8,10)">
                      <line
                        x1="0"
                        y1="0"
                        x2="12"
                        y2="0"
                        className="fax-line l1"
                      />
                      <line
                        x1="0"
                        y1="4"
                        x2="10"
                        y2="4"
                        className="fax-line l2"
                      />
                      <line
                        x1="0"
                        y1="8"
                        x2="8"
                        y2="8"
                        className="fax-line l3"
                      />
                    </g>
                  </svg>
                </span>
                <div className="loader-text">Sending fax...</div>
              </div>
            </div>
          )}
          <div className="container-fluid">
            {/* start page title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 main_heading">Compose - Send a Fax</h4>
                  <div className="page-title-right">
                    <DefaultView />
                  </div>
                </div>
              </div>
            </div>
            {/* end page title */}
            <div className="row">
              <div className="col-12">
                {/* Left sidebar */}
                <EmailLeftbar />
                {/* End Left sidebar */}
                {/* Right Sidebar */}
                <div className="email-rightbar mb-3 compose-section">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="mb-0">Compose Fax</h4>
                        <div>
                          {composeFaxLoader ? (
                            <button
                              type="button"
                              className="btn btn-primary waves-light waves-effect fax-loader-button"
                              disabled
                            >
                              <span className="fax-anim" aria-hidden>
                                <svg
                                  viewBox="0 0 36 36"
                                  width="36"
                                  height="36"
                                  xmlns="http://www.w3.org/2000/svg"
                                  role="img"
                                  aria-label="Sending fax"
                                >
                                  <g className="fax-paper-group">
                                    <rect
                                      x="6"
                                      y="4"
                                      width="18"
                                      height="24"
                                      rx="2"
                                      className="fax-paper"
                                      strokeWidth="1.6"
                                    />
                                    <path
                                      d="M24 4v6l4 0"
                                      className="fax-paper"
                                    />
                                  </g>
                                  <g
                                    className="fax-lines"
                                    transform="translate(8,10)"
                                  >
                                    <line
                                      x1="0"
                                      y1="0"
                                      x2="12"
                                      y2="0"
                                      className="fax-line l1"
                                    />
                                    <line
                                      x1="0"
                                      y1="4"
                                      x2="10"
                                      y2="4"
                                      className="fax-line l2"
                                    />
                                    <line
                                      x1="0"
                                      y1="8"
                                      x2="8"
                                      y2="8"
                                      className="fax-line l3"
                                    />
                                  </g>
                                </svg>
                              </span>
                              <span>Sending...</span>
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-primary waves-light waves-effect"
                              onClick={handleSave}
                              disabled={composeFaxLoader}
                            >
                              Send
                              <i className="mdi mdi-send ms-2" />
                            </button>
                          )}
                        </div>
                      </div>
                      {showQueuedAlert && (
                        <div
                          className="alert alert-success alert-dismissible fade show"
                          role="alert"
                        >
                          Your fax has been queued.{" "}
                          <Link to="/queues/OUT" className="fw-bold ms-2">
                            View all
                          </Link>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowQueuedAlert(false)}
                          ></button>
                        </div>
                      )}
                      {!getFromNumberLoader && fromNumbers.length < 1 && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="alert alert-info" role="alert">
                              You currently do not have an active fax number.
                              You can purchase one from{" "}
                              <Link to={"/buy-fax-phone-numbers"}>
                                <b>here</b>
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-1">
                            <label
                              htmlFor="example-text-input"
                              className="form-label mb-1 d-flex align-items-center"
                            >
                              Fax Number
                              <i
                                className="fas fa-info-circle ms-2 text-info"
                                style={{ cursor: "pointer" }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Enter up to 5 fax numbers. Use international format (e.g., +1234567890). Press Enter after each number or select from recent numbers."
                              ></i>
                            </label>
                            <div className="d-flex align-items-center gap-3">
                              <div style={{ flex: 1, position: "relative" }}>
                                <TagsInput
                                  value={faxNumber}
                                  onChange={handleChangeNumber}
                                  inputValue={tagInputValue}
                                  onChangeInput={handleTagInputChange}
                                  addOnBlur={false}
                                  onlyUnique={true}
                                  addKeys={[9, 13, 188]} // Tab, Enter, Comma
                                  removeKeys={[8]} // Backspace
                                  pasteSplit={(data) => {
                                    console.log("Raw pasted data:", data);
                                    // Don't process here, let handlePaste do it
                                    // Return empty array to prevent TagsInput from processing
                                    return [];
                                  }}
                                  inputProps={{
                                    placeholder:
                                      "Insert Fax Number and Hit Enter or use comma",
                                    onPaste: handlePaste,
                                    onFocus: () => setShowSentSuggestions(true),
                                  }}
                                  className={`custom-fax-number-input`}
                                />
                                {showSentSuggestions && (
                                  <div
                                    className="sent-suggestions shadow-sm"
                                    style={{
                                      border: "1px solid rgba(0,0,0,0.08)",
                                      borderRadius: 6,
                                      background: "#fff",
                                      maxHeight: 180,
                                      overflow: "auto",
                                      marginTop: 6,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                      zIndex: 50,
                                      position: "absolute",
                                      width: "100%",
                                    }}
                                  >
                                    <ul
                                      style={{
                                        listStyle: "none",
                                        margin: 0,
                                        padding: 8,
                                      }}
                                    >
                                      {getSentFaxNumbersLoader && (
                                        <li
                                          style={{
                                            padding: "8px 10px",
                                            color: "#666",
                                          }}
                                        >
                                          Loading...
                                        </li>
                                      )}
                                      {!getSentFaxNumbersLoader &&
                                        filteredSentSuggestions.length ===
                                        0 && (
                                          <li
                                            style={{
                                              padding: "8px 10px",
                                              color: "#666",
                                            }}
                                          >
                                            No recent numbers
                                          </li>
                                        )}
                                      {!getSentFaxNumbersLoader &&
                                        filteredSentSuggestions.map((n) => (
                                          <li
                                            key={n}
                                            onMouseDown={(e) => {
                                              e.stopPropagation();
                                              addSuggestion(n);
                                            }}
                                            style={{
                                              padding: "8px 10px",
                                              cursor: "pointer",
                                              borderRadius: 4,
                                            }}
                                            onMouseEnter={(e) =>
                                            (e.currentTarget.style.background =
                                              "rgba(0,0,0,0.04)")
                                            }
                                            onMouseLeave={(e) =>
                                            (e.currentTarget.style.background =
                                              "transparent")
                                            }
                                          >
                                            <div
                                              style={{
                                                fontSize: 13,
                                                color: "#111",
                                              }}
                                            >
                                              {n}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: 12,
                                                color: "#666",
                                              }}
                                            >
                                              Recent
                                            </div>
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                              </div>

                              <div>
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm contact-button"
                                  onClick={openContactsModal}
                                  title="Import from contacts"
                                  aria-label="Import contacts"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    padding: "0",
                                  }}
                                >
                                  <i
                                    className="fa fa-address-book me-2"
                                    aria-hidden="true"
                                  />
                                  Contacts
                                </button>
                              </div>
                            </div>
                          </div>
                          {errors.faxNumber && (
                            <div className="text-danger mt-1">
                              {errors.faxNumber}
                            </div>
                          )}
                        </div>
                        <div className="col-md-12 mt-2">
                          <div className="mb-1">
                            <label className="form-label">
                              Select From Number
                            </label>
                            <select
                              className={`form-select ${errors.header ? "is-invalid" : ""
                                }`}
                              value={fromNumber}
                              onChange={(e) => setFromNumber(e.target.value)}
                              disabled={getFromNumberLoader}
                            >
                              <option value={""}>Select From Number</option>
                              {fromNumbers &&
                                fromNumbers.map((data, index) => (
                                  <option key={index} value={data}>
                                    {data}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.fromNumber && (
                            <div className="text-danger mt-1">
                              {errors.fromNumber}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div className="">
                            <label
                              htmlFor="example-date-input"
                              className="form-label"
                            >
                              Select Alert
                            </label>
                            <select
                              className={`form-select ${errors.alert ? "is-invalid" : ""
                                }`}
                              value={alert}
                              onChange={(e) => setAlert(e.target.value)}
                              disabled={alertLoader}
                            >
                              <option value={""}>Select Alert</option>
                              {alertData &&
                                alertData.map((data, index) => (
                                  <option key={index} value={data.alert_ID}>
                                    {data.alert_value}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.alert && (
                            <div className="text-danger mt-1">
                              {errors.alert}
                            </div>
                          )}
                        </div>
                        <div className="col-md-12 mt-2">
                          <div className="mb-1">
                            <label
                              htmlFor="example-date-input"
                              className="form-label"
                            >
                              Select Header
                            </label>
                            <select
                              className={`form-select ${errors.header ? "is-invalid" : ""
                                }`}
                              value={header}
                              onChange={(e) => setHeader(e.target.value)}
                              disabled={faxHeaderloder}
                            >
                              <option value={""}>Select Header</option>
                              {faxHeaderData &&
                                faxHeaderData.map((data, index) => (
                                  <option key={index} value={data.header_ID}>
                                    {data.header_text}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.header && (
                            <div className="text-danger mt-1">
                              {errors.header}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-header">
                              <h4 className="card-title mb-2 d-flex align-items-center">
                                Select Files
                                <i
                                  className="fas fa-info-circle ms-2 text-info"
                                  style={{ cursor: "pointer" }}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Upload files to be sent as fax. Drag and drop or click to browse. Multiple files will be combined into a single fax."
                                ></i>
                              </h4>
                              <div
                                className="alert alert-info mb-0 mt-2 d-flex align-items-center"
                                role="alert"
                                style={{ padding: "12px 16px" }}
                              >
                                <i
                                  className="fa fa-info-circle me-3"
                                  style={{ fontSize: "1.5rem" }}
                                ></i>
                                <div>
                                  <div className="mb-1">
                                    <strong>Supported formats:</strong> PDF,
                                    DOC, DOCX, XLS, XLSX, PPT, PPTX, Images, and
                                    more
                                  </div>
                                  <div>
                                    <span
                                      className="badge bg-primary me-2"
                                      style={{
                                        fontSize: "0.85rem",
                                        padding: "6px 12px",
                                      }}
                                    >
                                      <i className="fa fa-file me-1"></i>
                                      Max Size: {MAX_FILE_SIZE_MB}MB per file
                                    </span>
                                    <span
                                      className="badge bg-primary"
                                      style={{
                                        fontSize: "0.85rem",
                                        padding: "6px 12px",
                                      }}
                                    >
                                      <i className="fa fa-copy me-1"></i>
                                      Max Pages: {MAX_PAGES} total
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`card-body ${isDragActive ? "active-dropzone" : ""
                                }`}
                              {...getRootProps()}
                              style={dropzoneStyle}
                            >
                              <input {...getInputProps()} />
                              <div className="dz-message needsclick">
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bx-cloud-upload" />
                                </div>
                                <h5>Drop files here or click to upload</h5>
                                {isCalculatingPages && (
                                  <div className="mt-2 text-primary">
                                    <i className="fas fa-spinner fa-spin me-2" />
                                    Calculating pages...
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {errors.uploadedFiles && (
                        <div className="alert alert-danger" role="alert">
                          <i className="fa fa-exclamation-triangle me-2"></i>
                          {errors.uploadedFiles}
                        </div>
                      )}
                      {uploadedFiles.length > 0 && (
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0">
                                Uploaded Files ({uploadedFiles.length})
                              </h5>
                              <div
                                className={`badge ${totalPages > MAX_PAGES
                                  ? "bg-danger"
                                  : "bg-success"
                                  } text-white px-3 py-2`}
                                style={{ fontSize: "0.9rem" }}
                              >
                                <i className="fa fa-file-alt me-2"></i>
                                {totalPages} / {MAX_PAGES} Pages
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        {uploadedFiles.map((uploadedFile, index) => {
                          let previewElement;
                          let iconClass = "";
                          let iconColor = "";
                          let fileType = "";

                          switch (uploadedFile.file.type) {
                            case "image/jpeg":
                            case "image/png":
                            case "image/gif":
                              previewElement = (
                                <img
                                  src={uploadedFile.preview}
                                  alt={`Preview-${index}`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              );
                              fileType = "Image";
                              break;
                            case "application/pdf":
                              iconClass = "fa fa-file-pdf";
                              iconColor = "text-danger";
                              fileType = "PDF";
                              break;
                            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                              iconClass = "fa fa-file-word";
                              iconColor = "text-primary";
                              fileType = "Word";
                              break;
                            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                              iconClass = "fa fa-file-excel";
                              iconColor = "text-success";
                              fileType = "Excel";
                              break;
                            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                              iconClass = "fa fa-file-powerpoint";
                              iconColor = "text-warning";
                              fileType = "PowerPoint";
                              break;
                            default:
                              iconClass = "fa fa-file";
                              iconColor = "text-secondary";
                              fileType = "File";
                          }

                          if (!previewElement) {
                            previewElement = (
                              <i
                                className={`${iconClass} ${iconColor}`}
                                style={{ fontSize: "3rem" }}
                              />
                            );
                          }

                          return (
                            <div className="col-md-6 col-lg-4 mb-3" key={index}>
                              <div
                                className="card file-card h-100 shadow-sm"
                                style={{
                                  position: "relative",
                                  overflow: "hidden",
                                }}
                              >
                                <div className="card-body p-3">
                                  <div className="d-flex align-items-start">
                                    <div
                                      className="file-thumb me-3 d-flex align-items-center justify-content-center"
                                      style={{
                                        minWidth: "60px",
                                        minHeight: "60px",
                                        width: "60px",
                                        height: "60px",
                                        background:
                                          uploadedFile.file.type.startsWith(
                                            "image/"
                                          )
                                            ? "transparent"
                                            : "#f8f9fa",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      {previewElement}
                                    </div>
                                    <div
                                      className="flex-grow-1"
                                      style={{ minWidth: 0 }}
                                    >
                                      <div className="d-flex justify-content-between align-items-start mb-1">
                                        <h6
                                          className="mb-1 text-truncate"
                                          title={uploadedFile.file.name}
                                          style={{ fontSize: "0.9rem" }}
                                        >
                                          {uploadedFile.file.name}
                                        </h6>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-link text-danger p-0 ms-2"
                                          aria-label={`Remove ${uploadedFile.file.name}`}
                                          onClick={() =>
                                            removeFile(uploadedFile)
                                          }
                                          style={{ fontSize: "1.1rem" }}
                                        >
                                          <i className="fa fa-times-circle" />
                                        </button>
                                      </div>
                                      <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
                                        <span
                                          className="badge bg-light text-dark"
                                          style={{ fontSize: "0.75rem" }}
                                        >
                                          {fileType}
                                        </span>
                                        <span
                                          className="badge bg-light text-dark"
                                          style={{ fontSize: "0.75rem" }}
                                        >
                                          {(
                                            uploadedFile.file.size / 1024
                                          ).toFixed(1)}{" "}
                                          KB
                                        </span>
                                        <span
                                          className="badge bg-primary"
                                          style={{ fontSize: "0.75rem" }}
                                        >
                                          <i className="fa fa-file-alt me-1"></i>
                                          {uploadedFile.pageCount || 1}{" "}
                                          {uploadedFile.pageCount === 1
                                            ? "page"
                                            : "pages"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="d-flex justify-content-end mt-3">
                        {composeFaxLoader ? (
                          <button
                            type="button"
                            className="btn btn-primary waves-light waves-effect fax-loader-button"
                            disabled
                          >
                            <span className="fax-anim" aria-hidden>
                              <svg
                                viewBox="0 0 36 36"
                                width="36"
                                height="36"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-label="Sending fax"
                              >
                                <g className="fax-paper-group">
                                  <rect
                                    x="6"
                                    y="4"
                                    width="18"
                                    height="24"
                                    rx="2"
                                    className="fax-paper"
                                    strokeWidth="1.6"
                                  />
                                  <path d="M24 4v6l4 0" className="fax-paper" />
                                </g>
                                <g
                                  className="fax-lines"
                                  transform="translate(8,10)"
                                >
                                  <line
                                    x1="0"
                                    y1="0"
                                    x2="12"
                                    y2="0"
                                    className="fax-line l1"
                                  />
                                  <line
                                    x1="0"
                                    y1="4"
                                    x2="10"
                                    y2="4"
                                    className="fax-line l2"
                                  />
                                  <line
                                    x1="0"
                                    y1="8"
                                    x2="8"
                                    y2="8"
                                    className="fax-line l3"
                                  />
                                </g>
                              </svg>
                            </span>
                            <span>Sending...</span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary waves-light waves-effect"
                            onClick={handleSave}
                            disabled={composeFaxLoader}
                          >
                            Send
                            <i className="mdi mdi-send ms-2" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* card */}
              </div>
              {/* end Col */}
            </div>
            {/* end row */}
          </div>
          {/* container-fluid */}
        </div>
        {/* End Page-content */}
        <div>
          {/* Contacts Modal (Bootstrap) */}
          {isContactsModalOpen && (
            <>
              <div
                className="modal fade show"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Select Contacts </h5>
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={closeContactsModal}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search contacts by name or number..."
                          value={contactsQuery}
                          onChange={(e) => setContactsQuery(e.target.value)}
                        />
                      </div>
                      <div className="list-group">
                        {contactsLoader && (
                          <div className="text-center py-4">
                            <i className="fas fa-spinner fa-spin fa-2x text-muted" />
                          </div>
                        )}

                        {!contactsLoader &&
                          contacts &&
                          contacts.length === 0 && (
                            <div className="text-muted">
                              You have no contacts.
                            </div>
                          )}

                        {!contactsLoader &&
                          contacts &&
                          contacts.length > 0 &&
                          contacts
                            .filter((c) => {
                              if (!contactsQuery) return true;
                              const q = contactsQuery.toLowerCase();
                              const name = (
                                c.name ||
                                c.fullname ||
                                c.contact_name ||
                                ""
                              ).toLowerCase();
                              const num = (
                                getContactNumber(c) || ""
                              ).toLowerCase();
                              return name.includes(q) || num.includes(q);
                            })
                            .map((c, idx) => {
                              const num = cleanNumber(
                                getContactNumber(c) || ""
                              );
                              const checked = selectedContacts.find(
                                (sc) =>
                                  cleanNumber(getContactNumber(sc) || "") ===
                                  num
                              );
                              return (
                                <label
                                  key={idx}
                                  className={`list-group-item d-flex align-items-center justify-content-between ${checked ? "active" : ""
                                    }`}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="d-flex align-items-center">
                                    <i
                                      className={`fa fa-user-circle fa-2x me-3 text-secondary ${checked ? "text-white" : "text-muted"
                                        }`}
                                    />
                                    <div>
                                      <div className="fw-semibold">
                                        {c.name ||
                                          c.fullname ||
                                          c.contact_name ||
                                          "Unknown"}
                                      </div>
                                      <div
                                        className={`${checked ? "text-white" : "text-muted"
                                          } small`}
                                      >
                                        {num || "No number"}
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={!!checked}
                                      onChange={() => toggleContactSelection(c)}
                                    />
                                  </div>
                                </label>
                              );
                            })}

                        {!contactsLoader &&
                          contacts &&
                          contacts.length > 0 &&
                          contacts.filter((c) => {
                            const q = contactsQuery.toLowerCase();
                            const name = (
                              c.name ||
                              c.fullname ||
                              c.contact_name ||
                              ""
                            ).toLowerCase();
                            const num = (
                              getContactNumber(c) || ""
                            ).toLowerCase();
                            return name.includes(q) || num.includes(q);
                          }).length === 0 && (
                            <div className="text-muted">
                              No contacts match your search.
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="me-auto">
                        Selected: {selectedContacts.length}/5
                      </div>
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={closeContactsModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={importSelectedContacts}
                        disabled={selectedContacts.length === 0}
                      >
                        Import
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </>
          )}
        </div>
      </div>
    );
  }
);

const mapStateToProps = (state) => {
  return {
    faxHeaderData: state.setting.faxHeaderData,
    faxHeaderloder: state.setting.faxHeaderloder,
    alertLoader: state.setting.alertLoader,
    alertData: state.setting.alertData,
    composeFaxLoader: state.inbox.composeFaxLoader,
    user: state.auth.user,
    getFromNumberLoader: state.auth.getFromNumberLoader,
    fromNumbers: state.auth.fromNumbers,
    contacts: state.auth.contacts,
    contactsLoader: state.auth.contactsLoader,
    sentFaxNumbers: state.sentFax.sentFaxNumbers,
    getSentFaxNumbersLoader: state.sentFax.getSentFaxNumbersLoader,
  };
};

export default connect(mapStateToProps, {
  actionGetFaxHeader,
  actionGetAlerts,
  actionComposeFax,
  actionGetFromNumbers,
  actionGetContacts,
  actionGetSendFaxNumbers,
})(ComponseFax);
